import PropTypes from 'prop-types';

const Comments = ({ value = 0 }) => (
  <svg
    width='45'
    height='16'
    viewBox='0 0 45 16'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g transform='translate(0, -2)'>
        <text
          fontFamily='Lato-Regular, Lato'
          fontSize='14'
          fontWeight='normal'
          letterSpacing='18'
          fill='#9A9EA1'
        >
          <tspan x='21' y='15'>
            {value}
          </tspan>
        </text>
        <path
          d='M15.9997118,9.19987033 C15.9997118,5.2298085 12.4109765,2 7.99985592,2 C3.58873537,2 0,5.2298085 0,9.19987033 C0,13.1699322 3.58873537,16.3997407 7.99985592,16.3997407 C9.13636878,16.3997407 10.233949,16.1890778 11.2648638,15.7736186 C13.0794978,16.8207997 15.5879859,17.1821266 15.6962506,17.1970596 C15.8333148,17.1997262 15.9266465,17.1434606 15.971979,17.0519956 C16.0231781,16.9493308 16.0029118,16.8255997 15.9218466,16.7445344 C15.3082576,16.1312122 14.8858652,14.8371021 14.7282681,13.0942002 C15.5607864,11.9320878 15.9997118,10.5878453 15.9997118,9.19987033 Z'
          fill='#000000'
          fillRule='evenodd'
          opacity='0.2'
        />
        <path
          d='M3.98925167,8.40082018 C3.98925167,8.56620985 3.85462294,8.69989734 3.68806882,8.69989734 C3.5215147,8.69989734 3.38688597,8.56620985 3.38688597,8.40082018 C3.38688597,6.75170868 5.37131417,4.77672659 7.03203642,4.77672659 C7.19859053,4.77672659 7.33321927,4.91041408 7.33321927,5.07580376 C7.33321927,5.24119343 7.19828935,5.37488092 7.03203642,5.37488092 C5.70351886,5.37488092 3.98925167,7.0815908 3.98925167,8.40082018 Z'
          fill='#FFFFFF'
          fillRule='evenodd'
        />
      </g>
    </g>
  </svg>
);

Comments.propTypes = {
  value: PropTypes.number,
};

export default Comments;
